module.exports = __webpack_public_path__ + "img/logo.ee004a05.png";